export const ECOMMERCE_MAPPING = [
  'e_catalog',
  'eProductList',
  'e_product',
  'e_product - productSlides',
  'e_product - eSingleProductAddOns',
  'e_product - ProdAttrMapping',
  'e_product - relatedProducts',
  'e_coupon',
  'e_checkout',
  'e_cart',
  'ECommerceCatalogue',
  'ECommerceProduct',
  'ECommerceCategories',
]
